// ======================================================================
// File Name       : document
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function registerDocumentDetail(params) {
  return commonCallApi({
    path: 'document/Edit',
    data: { ...params },
    muiltipart: 1,
  });
}

export function getDocumentDetail(params) {
  return commonCallApi({
    path: 'document/GetList',
    data: { ...params },
  });
}

export function editDocumentDetail(params) {
  return commonCallApi({
    path: 'document/Edit',
    data: { ...params },
    muiltipart: 1,
  });
}

export function downloadDocument(params) {
  return commonCallApi({
    path: 'document/Download',
    data: { ...params },
  });
}

